import * as react from "react";
import react_player from "react-player";

export function playerEx(isVideo, isPlaying, src) {
    const props = {};
    props["src"] = src;
    props["controls"] = true;
    props["playing"] = isPlaying;
    if (isVideo) {
        props["height"] = "100%";
    }
    else {
        props["height"] = "64px";
    }
    props["width"] = "100%";
    return react.createElement(react_player, props);
}

export const player = (src) => playerEx(true, false, src);

